import { inject, Injectable } from '@angular/core';
import { IconResolver, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
/**
 * Der AppIconRegistryService registriert zentral die eingebundenen SVGs innerhalb der Material-Icon Registry.
 * BEGRÜNDUNG: Diese Klasse ist lediglich zur Registrierung der SVGs notwendig (keine AFO)
 */
export class AppIconRegistryService {
  private readonly ICON_PATH = 'assets/svgs';

  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    this.registerIcons();
  }

  registerIcons(): void {
    const resolver: IconResolver = icon =>
      this.sanitizer.bypassSecurityTrustResourceUrl(`${this.ICON_PATH}/${icon}.svg`);
    this.iconRegistry.addSvgIconResolver(resolver);
  }
}
